import { NativeSelect } from '@/components/ui/native-select'
import { canonicalRole, OFFICE_ROLES, ROLE_LABELS } from '@/lib/roles'

interface RoleSelectProps {
  role: string
  disabled?: boolean
  onChange: (role: string) => void
  'aria-label'?: string
}

/** Escolha de papel: só os papéis do escritório (os antigos aparecem pelo equivalente). */
export function RoleSelect({ role, disabled, onChange, 'aria-label': ariaLabel = 'Papel' }: RoleSelectProps) {
  const current = canonicalRole(role) ?? ''
  return (
    <NativeSelect
      aria-label={ariaLabel}
      value={current}
      disabled={disabled}
      onChange={(event) => {
        if (event.target.value && event.target.value !== current) onChange(event.target.value)
      }}
    >
      {!current && <option value="">—</option>}
      {OFFICE_ROLES.map((r) => (
        <option key={r} value={r}>
          {ROLE_LABELS[r]}
        </option>
      ))}
    </NativeSelect>
  )
}
